(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.livenet_barrio_custom = {
    attach: function (context, settings) {

      $("body").find(".client-block-article , .joboffers-list-wrapper , .tag-description").parents(".tab-section").once().wrap("<div class='sidebar-tab bg-white'/>");

      // add class in tab-section

      $("body").find(".client-block-article , .joboffers-list-wrapper").parents(".tab-section").addClass("tab-wrap");

      // removeclass sidebar-list-tab

      $(".sidebar-tab .bg-white").removeClass("sidebar-list-tab .bg-white");

      //  for add wrapper class for search and mega menu
      $('#block-searchmenu, #block-megamenu').once().wrapAll('<div class="searchmenu-wrapper"></div>');

      // remove class on click of close icon

      $('.btn-close-mega-menu').click(function () {
        $('.navbar-we-mega-menu').removeClass('we-mobile-megamenu-active');
        $('body').removeClass('toggled');
        $(".overlay").remove();
      });

      // Article slider js //
      $('.responsive').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay: true,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: true
          }
        },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });

      // Image Slider in classified ads detail page
      $('.banner-images').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.ads-images'
      });
      $('.ads-images').slick({
        slidesToShow: 7,
        slidesToScroll: 1,
        asNavFor: '.banner-images',
        dots: false,
        centerMode: true,
        centerPadding: 0,
        focusOnSelect: true,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            infinite: true
          }
        },
          {
            breakpoint: 425,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 360,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      });


      // Dossiers slider JS //
      $('.dossiers-slider').slick({
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: true
          }
        },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });

      // Dossiers slider in half  js //
      $('.dossiers-slider-half').slick({
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true
          }
        },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
      // Dossiers slider in full  js //
      $('.dossiers-slider-full').slick({
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true
          }
        },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });

      // Video slider Js //
      $('.video-slider').slick({
        dots: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1
      });
      $('.article-carousel-slider').slick({
        dots: false,
        infinite: false,
        prevArrow: false,
        nextArrow: false,
        autoplaySpeed: 12000,       
        speed: 1200,
        cssEase: "ease",
        pauseOnHover: true,
        slidesToShow: 1,
        slidesToScroll: 1
      });
      $('.article-carousel-slider-rotation-nav').slick({
        dots: false,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 12000,       
        speed: 1200,
        cssEase: "ease",
        pauseOnHover: true,
        slidesToShow: 1,
        slidesToScroll: 1
      });
      $('.dossier-slider-rotation-nav').slick({
        dots: false,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 12000,       
        speed: 1200,
        cssEase: "ease",
        pauseOnHover: true,
        slidesToShow: 2,
        slidesToScroll: 1
      });
      $('.article-carousel-slider-nav').slick({
        dots: false,
        infinite: false,
        autoplaySpeed: 12000,       
        speed: 1200,
        cssEase: "ease",
        pauseOnHover: true,
        slidesToShow: 1,
        slidesToScroll: 1
      });
      $('.article-carousel-slider-rotation').slick({
        dots: false,
        autoplay: true,
        infinite: false,
        prevArrow: false,
        nextArrow: false,
        autoplaySpeed: 12000,       
        speed: 1200,
        cssEase: "ease",
        pauseOnHover: true,
        slidesToShow: 1,
        slidesToScroll: 1
      });
      // Menu code start //
      $(".mob-menu-icon").click(function () {
        $(".nav-menu-wrapper").toggleClass('showmenu');
        if ($(this).hasClass('Menuactive')) {
          $('.down-arrow').removeClass('down-up');
          $('.inner-menu').css('display', 'none');
        }
      });
      $('.navbar-nav li:has(ul)').prepend('<span class="down-arrow"></span>');
      $('.down-arrow').click(function () {
        $(this).siblings('ul.inner-menu').slideToggle();
        // $(this).closest("div").find("ul.inner-menu").slideToggle();
        $(this).toggleClass('down-up');
      });

      // Details page slider JS //
      $('.details-slider').slick({
        dots: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1
      });

      // Navbar menu link clickble JS //
      $('.navbar-nav li.menu-item--expanded > a').click(function () {
        //if ($(window).width() > 769) {
          location.href = this.href;
        //}
      });

      // Header menu sticky scroll effect //
      var stickyOffset = $('.nav-menu-wrapper').offset().top + 60;

      $(window).scroll(function () {
        var sticky = $('.nav-menu-wrapper'),
          scroll = $(window).scrollTop();

        if (scroll >= stickyOffset) sticky.addClass('fixed');
        else sticky.removeClass('fixed');
      });



      // Lightbox JS //
      lightbox.option({
        'fadeDuration': 300,
        'resizeDuration': 300,
        'wrapAround': true
      });

      //cache the lis since we need to use it again
      var $lis = $('.ads-images .slick-track .slick-slide');
      //check if there are more than 5 elements
      if ($lis.length < 7) {
        //if so get the last 2 elements and add the class
        $(".ads-images .slick-track").addClass("custom-track")

      } else {
        $(".ads-images .slick-track").removeClass("custom-track")
      }


      // for responsive mega menu
      $(window).trigger("resize");
      $.fn.linkwidfn();
      $('.wraparrowlink .down-arrow').on('click', function() {
        $(this).parent().parent().toggleClass('open-custom-submenu');
      });

      $(window).on("resize", function (e) {
        if ($(window).width() < 768) {
          $('.we-mega-menu-submenu ul li >a , .social-icons a').click(function() {
            window.location.href = this.href;
            return false;
          });
        }
      });
    }
  };

  $.fn.linkwidfn = function() {
    $('.we-mega-menu-submenu .mob-menu .nav-item').each(function(){
      $(this).find( ".down-arrow, .nav-link" ).wrapAll( "<div class='wraparrowlink'></div>" );
    })
  }


})(jQuery, Drupal);





},{}]},{},[1])